// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_10-7";
export var adjustableWidthBorderHeld = "_10-8";
export var arrow = "_10-3";
export var arrowButton = "_10-4";
export var headerCell = "_10-0";
export var help = "_10-2";
export var icon = "_10-1";
export var iconWrapper = "_10-6";
export var noBorder = "_10-b";
export var nonAdjustableWidthBorder = "_10-9";
export var nonAdjustableWidthBorderHeld = "_10-a";
export var textButton = "_10-5";